import type { ReviewTypeOption } from "@remi/types/reviewType";

import { hasCapability, type User } from "../base";

export const review = {
  create: (user: User, reviewType?: ReviewTypeOption) => {
    if (hasCapability(user, "review.create")) {
      return true;
    }
    if (reviewType === "CONTRACTOR_REVIEW_HOMEOWNER" || reviewType === "CONTRACTOR_REVIEW_REMI") {
      return hasCapability(user, "review.create.contractor");
    }
    if (reviewType === "WORKMANSHIP" || reviewType === "COORDINATION") {
      return hasCapability(user, "review.create.workmanship");
    }
    return false;
  },
  read: (user: User) => hasCapability(user, "review.read"),
};
